import { apiSlice } from "features/api/apiSlice";
// import { transformAppointment } from "./transformAppointment";

const getDataSharingAgreement = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDataSharingAgreement: build.query({
      query: () => "/cms/data-sharing-agreement",
      transformResponse: (res) => res.d.items.map(),
      providesTags: (result) => {
        if (result) {
          const tagged = result.map(({ id }) => ({ type: "Appointment", id }));

          return [...tagged, "Appointment"];
        } else {
          return ["Appointment"];
        }
      },
    }),
  }),
});

export const { useGetDataSharingAgreementCMSQuery } = getDataSharingAgreement;
